// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ba97dcd7","977":"9a7a7b6f"}[chunkId] + ".chunk.js";
};